import { Warning, WarningGroup, WarningLevel } from "../../../models";
import { DataProviderArgs } from "../../DataStore/DataProvider";
import { DataStoreTable } from "./DataStoreTable";

export type IWarning = {
    id: string;
    title: string;
    description: string;
    group: WarningGroup;
    level: WarningLevel;
};

export class WarningTable extends DataStoreTable<IWarning> {
    constructor(args: DataProviderArgs) {
        super(args, "warning", Warning, (obj: any) => obj as IWarning);
    }
}
